enum ActionType {
    REQUEST_LATEST_LOCATION_THREAT_SCORES = '[CORE/LLTS] GET LATEST LOCATION THREAT SCORES',
    RECEIVE_LATEST_LOCATION_THREAT_SCORES = '[CORE/LLTS] SET LATEST LOCATION THREAT SCORES',
}

export default ActionType
